import { NextRequest } from 'next/server'

import { isGooglebotAgent } from './utils'

export const withPrometheusMetricsAppRoute = (
  route: string,
  handler: (req: NextRequest, ...args: unknown[]) => Promise<Response>
): ((req: NextRequest, ...args: unknown[]) => Promise<Response>) => {
  return async (req, ...args) => {
    const start = process.hrtime()
    const response = await handler(req, ...args)
    const end = process.hrtime(start)
    const duration = end[0] + end[1] / 1e9

    const labels = {
      method: req.method,
      path: route,
      code: response.status,
      is_googlebot_user_agent: isGooglebotAgent({
        'user-agent': req.headers.get('user-agent') ?? undefined,
      }).toString(),
    }

    if (process.env.NEXT_RUNTIME === 'nodejs') {
      const { PrometheusMetrics } = await import('../register')
      PrometheusMetrics.instance.registerMetrics(labels, duration)
    }

    return response
  }
}
